import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.scss']
})
export class PrimaryButtonComponent implements OnInit {
  @Input() label: string;
  @Input() type: string;
  @Input() disabled: boolean;
  @Input() item: any;
  @Output() action = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
  }

  onClickHandler() {
    this.action.emit();
  }

}
